import {useStore} from '../../../core/store';
import React, {FC, useCallback, useEffect, useRef, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {SimpleTarget} from '../simple-target/simple-target';
import {Position2D} from '../simple-target/simple-target-interfaces';
import SendIcon from '@material-ui/icons/Send';

import {observer} from 'mobx-react-lite';
import {Button, makeStyles} from '@material-ui/core';
import {GameModel2} from '../../../core/interfaces';
import WinScreen from '../game-win-screen/game-win-screen';
import {DEFAULT_MELODY_DURATION} from '../../../core/constants';

interface GameOneCLickRouterParams {
    id: string;
}

const useComponentStyles = makeStyles({
    rootWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    game: {
        backgroundColor: '#fdfaf2',
    },
    infoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        paddingBottom: '40px',
    },
    preview: {
        height: '400px',
        borderRadius: '50px',
        marginBottom: '40px',
    },
    playButton: {
        fontSize: '140%',
    },
    playButtonText: {
        padding: '10px',
    }
});

let afterHitTimeoutID: ReturnType<typeof setTimeout>;

export const GameOne2CLick: FC = observer(() => {
    const {id} = useParams<GameOneCLickRouterParams>();
    const componentClasses = useComponentStyles();
    const store = useStore();
    const game = store.games2.find((game) => game.id === id);
    const history = useHistory();
    const gameEl = useRef<HTMLDivElement>(null);
    const [isInGamePlayMode, setGamePlayMode] = useState(false);
    const [showWinScreen, setShowWinScreen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagesToSelect, setImagesToSelect] = useState({
        image1: null,
        image2: null
    });
    const [audio, setAudio] = useState(new Audio('/assets/example.mp3'));


    useEffect(() => {
        const gameDOMEl = gameEl.current;
        // const handleFullscreenChange = (event) => {
        //     const isFullScreen = document.fullscreenElement === event.target;
        //     if (!isFullScreen) {
        //         clearTimeout(afterHitTimeoutID);
        //         setShowWinScreen(false)
        //         if (window.audio) {
        //             window.audio.pause();
        //             window.audio.currentTime = 0;
        //         }
        //     }
        //     setGamePlayMode(isFullScreen);
        //     if (!isFullScreen) {
        //         setShowWinScreen(false);
        //
        //     }
        // };

        function getRandomNumber() {
            return Math.floor(Math.random() * ((game.screens.length - 1) - 0 + 1)) + 0
        }

        if (game) {
            var randomnumber1 = getRandomNumber();
            var randomnumber2 = 0;
            while (randomnumber2 === randomnumber1) {
                randomnumber2 = getRandomNumber()
            }

            setImagesToSelect({
                image1: game.screens[randomnumber1],
                image2: game.screens[randomnumber2]
            })
        }
        // gameDOMEl?.addEventListener("fullscreenchange", handleFullscreenChange);
        // return function cleanup() {
        //     gameDOMEl?.removeEventListener("fullscreenchange", handleFullscreenChange);
        // }
    }, [game]);

    // useEffect(() => {
    //   if (game) setAudio(new Audio(URL.createObjectURL(game.audio)))
    // }, [])

    useEffect(() => {
        document.addEventListener('keydown', keydownListener);
        return () => {
            document.removeEventListener('keydown', keydownListener);
        }
    }, [showWinScreen, isInGamePlayMode, selectedImage, audio, imagesToSelect])

    function keydownListener(e) {
        if (isInGamePlayMode && !showWinScreen && game && !selectedImage) {
            if (e.keyCode == 32 || e.keyCode == 13) {
                e.preventDefault()
                const field = e.keyCode == 32 ? 'image1' : 'image2'
                startMusic(imagesToSelect[field])
            }
        }
        if (e.keyCode == 27) {
            e.preventDefault()
            if (selectedImage) {
                resetGame()
            }
        }
    }

    function startMusic(image) {
        setSelectedImage(image.picture)
        window.image = image.picture
        window.audio = new Audio(URL.createObjectURL(image.audio))
        // setAudio(audio)
        setTimeout(() => {
            if (window.image) {
                nextGame()
                console.log('resetGame()')
            }
            console.log('image.melodyDuration', image.melodyDuration)
        }, (image.melodyDuration) * 1000)
        setTimeout(() => {
            const wrap = document.querySelector('.game2-finish')
            if (wrap) {
                wrap.classList.add('game2-finish--show')
                window.audio.play();
            }
        }, 100)
    }

    function resetGame() {
        setSelectedImage(null)
        window.image = null
        setShowWinScreen(false);
        setGamePlayMode(false)
        // document.exitFullscreen()
        console.log(window.audio)
        if (window.audio) {
            window.audio.pause();
            window.audio.currentTime = 0;
        }
    }
    function nextGame() {
        setSelectedImage(null)
        window.image = null
        if (window.audio) {
            window.audio.pause();
            window.audio.currentTime = 0;
        }
        function getRandomNumber() {
            return Math.floor(Math.random() * ((game.screens.length - 1) - 0 + 1)) + 0
        }

        var randomnumber1 = getRandomNumber();
        var randomnumber2 = 0;
        while (randomnumber2 === randomnumber1) {
            randomnumber2 = getRandomNumber()
        }

        setImagesToSelect({
            image1: game.screens[randomnumber1],
            image2: game.screens[randomnumber2]
        })
    }

    const requestGameFullscreen = () => gameEl.current?.requestFullscreen();

    const handleGameStart = async () => {
        setGamePlayMode(true);
        // await requestGameFullscreen();
    };

    return (
        <div className={`users-game-2 ${componentClasses.rootWrapper}`}>
            {!game && <div>Игра не найдена</div>}
            {game &&
            <div className={componentClasses.infoWrapper}>
              <h1>{game.title}</h1>
              <img src={URL.createObjectURL(game.screens[0].picture)} className={componentClasses.preview}
                   alt="Превью игры"></img>
              <Button onClick={handleGameStart} className={componentClasses.playButton} variant="contained"
                      color="primary">
                <span className={componentClasses.playButtonText}>Играть</span><SendIcon/>
              </Button>
            </div>
            }
            <div className={`game-background ${game?.darkMode && 'game-background--dark '}` + componentClasses.game}
                 ref={gameEl}>
                {
                    isInGamePlayMode && !showWinScreen && game &&
                    <>
                        {game.showExitBtn && <Button
                          onClick={() => {
                              resetGame();
                              history.push('/')
                          }}
                          className='exit-btn'
                          variant="contained" color="primary" size="large">
                          Выход
                        </Button>}
                      <div className="game2-start">
                        <div className="game2-start__container">
                          <div className="game2-start__btn"
                               onClick={() => startMusic(imagesToSelect.image1)}
                              // @ts-ignore
                               style={{backgroundColor: imagesToSelect.image1.color}}>
                            <img src={URL.createObjectURL(imagesToSelect.image1.picture)} alt="Картинка"/>
                          </div>
                          <div className="game2-start__btn"
                               onClick={() => startMusic(imagesToSelect.image2)}
                              // @ts-ignore
                               style={{backgroundColor: imagesToSelect.image2.color}}>
                            <img src={URL.createObjectURL(imagesToSelect.image2.picture)} alt="Картинка"/>
                          </div>
                        </div>
                      </div>
                        {selectedImage &&
                        <div className={`game2-finish game-background ${game?.darkMode && 'game-background--dark '}`}
                             onClick={() => resetGame()}>
                          <img src={URL.createObjectURL(selectedImage)} alt="картинка"/>
                        </div>}
                    </>
                }
            </div>
        </div>
    );
})

export default GameOne2CLick;
